import React , {useEffect,useState} from "react";
import { useParams } from "react-router-dom";
import GlobalResource from "../../pages/common/globalresource";
import { getIdData } from "../../../lib/studentinfo";
import Student12TopMenu from "../studentInfo/student12topmenu"
import Student911TopMenu from "../studentInfo/student911topmenu"


export default function InstructorStudentResource() {

  let { slug } = useParams();

  const [isStudent911, setisStudent911] = useState(false);
  const [isStudent12, setisStudent12] = useState(false);

  async function GetData() {
    const info = await getIdData(slug);
    if (info[0].role === "Student911") {
      setisStudent911(true);
    } else if (info[0].role === "Student12") {
      setisStudent12(true);
    }
  }
   
    useEffect(() => {
      GetData();
    }, []);


  return (
    <>
    {isStudent911 && <Student911TopMenu slug={slug} activeMenu={"Resource"} /> }
    {isStudent12 && <Student12TopMenu slug={slug} activeMenu={"Resource"} /> }
      <div className="tak-instruct-group">
        <div className="row">
          <div className="col-md-12">
            <GlobalResource slug={slug} isStudent={false} />
          </div>
        </div>
      </div>
    </>
  );
}
